const NoFuelSurchargeSvg = () => (
  <svg
    fill="currentColor"
    height="18px"
    viewBox="0 -960 960 960"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M160-120v-640q0-33 23.5-56.5T240-840h240q33 0 56.5 23.5T560-760v280h40q33 0 56.5 23.5T680-400v180q0 17 11.5 28.5T720-180q17 0 28.5-11.5T760-220v-288q-9 5-19 6.5t-21 1.5q-42 0-71-29t-29-71q0-32 17.5-57.5T684-694l-84-84 42-42 148 144q15 15 22.5 35t7.5 41v380q0 42-29 71t-71 29q-42 0-71-29t-29-71v-200h-60v300H160Zm80-440h240v-200H240v200Zm480 0q17 0 28.5-11.5T760-600q0-17-11.5-28.5T720-640q-17 0-28.5 11.5T680-600q0 17 11.5 28.5T720-560Z" />
    <line
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="60"
      x1="120"
      x2="840"
      y1="-120"
      y2="-840"
    />
  </svg>
);

export default NoFuelSurchargeSvg;
